export const COGNITO = {
  REGION: "sa-east-1",
  USER_POOL_ID: "sa-east-1_46q534hn9",
  APP_CLIENT_ID: "3usrcjiu7sl7l87mkvpnbbellf",
};